import React, { useState } from 'react';
import './App.css';

function App() {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const handlePurchase = (price: string) => {
    window.location.href = 'https://copecart.com/us/products/99318849/checkout';

  };

  const stats = [
    { number: '500+', label: 'Clients Scaled' },
    { number: '25M+', label: 'Combined Followers' },
    { number: '450%', label: 'Average Growth Rate' },
    { number: '99%', label: 'Client Retention' }
  ];

  const testimonials = [
    {
      name: 'Sarah Johnson',
      role: 'Fashion Influencer | 1.2M Followers',
      image: 'https://i.pravatar.cc/150?img=1',
      content: 'Their Instagram growth strategies helped me gain 500K authentic followers in 6 months. My engagement rate increased from 2% to 7%, and brand deals tripled!'
    },
    {
      name: 'Mark Chen',
      role: 'TikTok Creator | 3.5M Followers',
      image: 'https://i.pravatar.cc/150?img=3',
      content: 'The viral content formula they taught me led to 5 videos hitting over 1M views each. My account grew from 100K to 3.5M followers in just 4 months.'
    },
    {
      name: 'Emma Davis',
      role: 'Fitness Brand Owner | 800K Following',
      image: 'https://i.pravatar.cc/150?img=5',
      content: 'Their cross-platform strategy helped us dominate both Instagram and TikTok. We have seen a 300% increase in social media-driven sales since working together.'
    }
  ];

  return (
    <div className="App">
      <nav className="navbar">
        <div className="logo">Apex Growth</div>
        <div className="nav-links">
          <a href="#services">Services</a>
          <a href="#process">Our Process</a>
          <a href="#results">Results</a>
          <a href="#pricing">Pricing</a>
        </div>
      </nav>

      <header className="header">
        <div className="header-content">
          <h1>Dominate Instagram & TikTok With Proven Strategies</h1>
          <p className="subtitle">Expert-driven growth tactics that have generated over 25M+ followers for our clients across platforms</p>
          <div className="cta-buttons">
            <button className="primary-btn" onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}>
              Scale Your Account
            </button>
            <button className="secondary-btn" onClick={() => document.getElementById('process')?.scrollIntoView({ behavior: 'smooth' })}>
              See Our Process
            </button>
          </div>
        </div>
        <div className="header-stats">
          {stats.map((stat, index) => (
            <div key={index} className="stat-box">
              <h3>{stat.number}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </header>

      <section id="services" className="services">
        <h2>Platform-Specific Growth Expertise</h2>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">📱</div>
            <h3>Instagram Mastery</h3>
            <p>Advanced growth strategies including Reels optimization, hashtag research, engagement rate boosting, and content virality frameworks</p>
          </div>
          <div className="service-card">
            <div className="service-icon">🎵</div>
            <h3>TikTok Domination</h3>
            <p>Trending sound analysis, FYP optimization, viral hooks creation, and strategic posting schedules for maximum reach</p>
          </div>
          <div className="service-card">
            <div className="service-icon">🎯</div>
            <h3>Content Strategy</h3>
            <p>Data-driven content planning, trend forecasting, and cross-platform content adaptation for maximum impact</p>
          </div>
          <div className="service-card">
            <div className="service-icon">💰</div>
            <h3>Monetization</h3>
            <p>Brand deal acquisition, affiliate marketing optimization, and product launch strategies</p>
          </div>
        </div>
      </section>

      <section id="process" className="process">
        <h2>Our Data-Driven Growth Process</h2>
        <div className="process-timeline">
          <div className="process-step">
            <div className="step-number">1</div>
            <h3>Account Analysis</h3>
            <p>Deep dive into your metrics, audience demographics, and content performance using proprietary AI tools</p>
          </div>
          <div className="process-step">
            <div className="step-number">2</div>
            <h3>Growth Strategy</h3>
            <p>Custom roadmap including content pillars, posting schedule, and engagement tactics specific to your niche</p>
          </div>
          <div className="process-step">
            <div className="step-number">3</div>
            <h3>Content Optimization</h3>
            <p>Implementation of viral hooks, trending audio, and platform-specific best practices</p>
          </div>
          <div className="process-step">
            <div className="step-number">4</div>
            <h3>Scale & Monetize</h3>
            <p>Leverage growing audience for brand deals, product launches, and sustainable income streams</p>
          </div>
        </div>
      </section>

      <section id="results" className="results">
        <h2>Proven Results Across Platforms</h2>
        <div className="testimonials">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-header">
                <img src={testimonial.image} alt={testimonial.name} className="testimonial-image" />
                <div className="testimonial-info">
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.role}</p>
                </div>
              </div>
              <p className="testimonial-content">{testimonial.content}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="pricing" className="pricing">
        <h2>Growth Investment Plans</h2>
        <p className="pricing-subtitle">Choose your path to social media dominance</p>
        
        <div className="pricing-container">
          <div className="price-box" onClick={() => handlePurchase('1000')}>
            <div className="price-header">
              <h3>Growth Accelerator</h3>
              <p className="price">$1,000</p>
              <p className="price-description">Perfect for creators ready to scale from 0-100K followers</p>
            </div>
            <ul>
              <li>Platform-Specific Growth Strategy</li>
              <li>Content Calendar & Posting Schedule</li>
              <li>2 Monthly Strategy Calls</li>
              <li>Trending Audio & Hashtag Research</li>
              <li>Engagement Rate Optimization</li>
              <li>Basic Analytics Dashboard</li>
              <li>Viral Hook Templates</li>
              <li>30 Days Email Support</li>
            </ul>
            <button className="price-button">Start Your Growth Journey</button>
          </div>

          <div className="price-box featured" onClick={() => handlePurchase('2500')}>
            <div className="featured-badge">Most Popular</div>
            <div className="price-header">
              <h3>Elite Creator Package</h3>
              <p className="price">$2,500</p>
              <p className="price-description">For serious creators aiming for 500K+ followers</p>
            </div>
            <ul>
              <li>Everything in Growth Accelerator</li>
              <li>Advanced Content Strategy</li>
              <li>Weekly 1:1 Coaching Calls</li>
              <li>Viral Content Formula Guide</li>
              <li>Brand Deal Acquisition Strategy</li>
              <li>Monetization Roadmap</li>
              <li>Cross-Platform Growth Plan</li>
              <li>Priority Support via WhatsApp</li>
              <li>Monthly Performance Analytics</li>
              <li>Custom Engagement Groups Access</li>
            </ul>
            <button className="price-button featured">Accelerate Your Growth</button>
          </div>

          <div className="price-box" onClick={() => handlePurchase('5000')}>
            <div className="price-header">
              <h3>Agency Growth Package</h3>
              <p className="price">$5,000</p>
              <p className="price-description">For agencies and serious brands ready to scale multiple accounts</p>
            </div>
            <ul>
              <li>Everything in Elite Creator Package</li>
              <li>Manage Up to 3 Social Media Accounts</li>
              <li>Daily Strategy Support</li>
              <li>Custom Content Production Guide</li>
              <li>Advanced Analytics Dashboard</li>
              <li>Competitor Analysis Reports</li>
              <li>Trend Prediction AI Access</li>
              <li>24/7 VIP Support</li>
              <li>Monthly Strategy Review</li>
              <li>ROI Tracking System</li>
            </ul>
            <button className="price-button">Scale Your Agency</button>
          </div>

          <div className="price-box" onClick={() => handlePurchase('10000')}>
            <div className="price-header">
              <h3>Enterprise Solution</h3>
              <p className="price">$10,000</p>
              <p className="price-description">Complete done-for-you social media empire building</p>
            </div>
            <ul>
              <li>Everything in Agency Growth Package</li>
              <li>Manage Up to 7 Social Media Accounts</li>
              <li>Dedicated Account Manager</li>
              <li>Content Creation Team</li>
              <li>Custom Strategy Development</li>
              <li>Brand Partnership Introductions</li>
              <li>Influencer Network Access</li>
              <li>Crisis Management</li>
              <li>Quarterly Business Strategy</li>
              <li>White Label Reports</li>
            </ul>
            <button className="price-button">Build Your Empire</button>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Explode Your Social Media Growth?</h2>
        <p>Join hundreds of successful creators who have scaled to 6-7 figure followings using our proven systems</p>
        <button className="cta-button" onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}>
          Start Your Growth Journey
        </button>
      </section>

      <footer>
        <div className="footer-content">
          <div className="footer-section">
            <h4>Apex Growth</h4>
            <p>Your partner in building a powerful social media empire across Instagram and TikTok.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <a href="#services">Services</a>
            <a href="#process">Our Process</a>
            <a href="#results">Results</a>
            <a href="#pricing">Pricing</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2025 Apex Growth. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App; 